import { MessageDto } from '@services/_api';
import client from '@services/client';

export const getUpdateMessages = (environment: string, type: string) => {
  return client.api.updateMessageControllerGetUpdateMessage({ environment, type });
};

export const updateMessage = (environment: string, type: string, messages: MessageDto[]) => {
  return client.api.updateMessageControllerUpdateMessage({ environment, type, messages });
};
